var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from "react";
import { ModalV2, ModalV2Content, ModalV2Footer, ModalV2Title, Icon, ButtonGroup } from "../../index";
var ModalV2Control = forwardRef(function (_a, ref) {
    var id = _a.id, onClose = _a.onClose, size = _a.size, className = _a.className, style = _a.style, title = _a.title, iconTitle = _a.iconTitle, iconSvgTitle = _a.iconSvgTitle, children = _a.children, buttons = _a.buttons, otherProps = __rest(_a, ["id", "onClose", "size", "className", "style", "title", "iconTitle", "iconSvgTitle", "children", "buttons"]);
    var idModalTitle = useMemo(function () {
        return id + "-title";
    }, [id]);
    return (React.createElement(ModalV2, __assign({}, otherProps, { ref: ref, id: id, idModalTitle: idModalTitle, onClose: onClose, size: size, className: className, style: style }),
        React.createElement(ModalV2Content, null,
            React.createElement(ModalV2Title, { id: idModalTitle },
                iconTitle ? React.createElement(Icon, { icon: iconTitle }) : undefined,
                iconSvgTitle ? React.createElement(Icon, { iconSvg: iconSvgTitle }) : undefined,
                title),
            children),
        React.createElement(ModalV2Footer, null,
            React.createElement(ButtonGroup, { iconPosition: "left", align: "right", inline: "lg", reverse: true }, buttons))));
});
export default ModalV2Control;
